import Icon from '../components/Icon.vue'

Icon.register({
  haykal: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M496.3 202.5L386.3 187.1 428.1 82.7C434.7 66.1 416.5 50.6 401.5 60.1L307.4 120 273.4 12.8C270.6 4.3 263.3 0 256 0 248.7 0 241.4 4.3 238.7 12.8L204.6 120 110.5 60.1C95.5 50.6 77.3 66.1 83.9 82.8L125.8 187.1 15.8 202.5C-1.8 205-5.9 228.8 9.7 237.2L107.9 289.9 33.4 373.4C22.5 385.6 31.7 404.3 46.7 404.3 48 404.3 49.4 404.2 50.8 403.9L159.3 380.2 155.2 492.8C154.8 504.4 164.1 512 173.6 512 178.8 512 184 509.8 187.8 504.8L256 415.9 324.2 504.8C328 509.8 333.2 512 338.4 512 347.9 512 357.2 504.4 356.8 492.8L352.7 380.2 461.3 403.9C478.6 407.6 490.5 386.7 478.6 373.4L404.1 289.8 502.3 237.2C517.9 228.8 513.8 205 496.2 202.5zM338.5 311.7L286.6 300.4 288.6 354.2 256 311.7 223.4 354.2 225.4 300.4 173.5 311.7 209.1 271.8 162.2 246.6 214.7 239.2 194.7 189.3 239.7 217.9 256 166.7 272.3 217.9 317.2 189.3 297.3 239.2 349.8 246.6 302.9 271.8 338.5 311.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/haykal.js
// module id = 4FOi
// module chunks = 144